// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bar[data-v-1ed5ca5c]{text-align:center;padding:6px 0 5px;font-size:15px;letter-spacing:1.5px}[class*=stg][data-v-1ed5ca5c]{background:#add8e6}[class*=dev][data-v-1ed5ca5c]{background:#90ee90}.forceLogin[data-v-1ed5ca5c]{background:#f08080}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
